import React, { useState, useEffect, Suspense } from 'react';
import { Link, useLocation, useNavigate } from 'react-router';
import Navbar from './components/navbar.js';
import MobileNavbar from './components/MobileNavbar.js';
import Footer from "./components/Footer.js";
// import { RxHamburgerMenu } from "react-icons/rx"; // commented out for MENU text button
import './App.css';
import { AnimatePresence } from 'framer-motion';

const Landing = React.lazy(() => import('./components/Landing.js'));
const Contact = React.lazy(() => import('./components/Contact.js'));
const SelectedWorks = React.lazy(() => import('./components/SelectedWorks.js'));
const About = React.lazy(() => import('./components/About.js'));
const Sketchbooks = React.lazy(() => import('./components/Sketchbooks.js'));
const Exhibitions = React.lazy(() => import('./components/Exhibitions.js'));
const Statement = React.lazy(() => import('./components/Statement.js'));
const StatementBackup = React.lazy(() => import('./components/StatementBackup.js'));
const Interviews = React.lazy(() => import('./components/Interviews.js'));
const InterviewsBackup = React.lazy(() => import('./components/InterviewsBackup.js'));
const Illustrations = React.lazy(() => import('./components/Illustrations.js'));
const IllustrationsSubpage = React.lazy(() => import('./components/IllustrationsSubpage.js'));
const NotFound = React.lazy(() => import('./components/NotFound.js'));

function App(props) {
  // Active page state variable defines which page will be displayed. The value of active page is controlled through 
  // the navbar options
  const [activePage, setActivePage] = useState(props.activePage);
  const [activeSubPage, setActiveSubPage] = useState(props.activeSubPage);
  const [mobileNavbar, setMobileNavbar] = useState(false);
  const location = useLocation()
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state === null) {
      // Set Active Page
      if (props.activePage === null) {
        setActivePage("LANDING");
      } else {
        setActivePage(props.activePage);
      }

      // Set Active Sub Page
      if (props.activeSubPage === null) {
        setActiveSubPage("NEWYORK");
      } else {
        setActiveSubPage(props.activeSubPage);
      }
    } else {
      setActivePage(location.state.activePage);
      setActiveSubPage(location.state.subPage);
    }
    setMobileNavbar(false);
  }, [location.state, props.activePage, props.activeSubPage]);

  useEffect(() => {
    if (!props.subPage) return;
    if (location.state === null) {
      setActivePage(props.subPage);
    } else {
      setActivePage(location.state.subPage);
    }
    setMobileNavbar(false);
  }, [props.subPage]);

  const showMobileNavbar = () => {
    setMobileNavbar(true);
  }

  const closeMobileNavbar = () => {
    setMobileNavbar(false);
  }

  return (
    <div id="outer-wrapper" className="home-outer-wrapper">
      <div className="home-header">
        <Link to="/" onClick={() => navigate(location.pathname, { replace: true, state: {} })} className="header-hank-link" state={{ activePage: "LANDING" }}><p className="header-hank-name">HANK BLAUSTEIN</p></Link>
        <button onClick={() => showMobileNavbar()} className="mobile-hamburger-btn" aria-label="Open navigation menu">
          {/* <RxHamburgerMenu className="mobile-hamburger-icon" /> */}
          <span className="mobile-hamburger-label">MENU</span>
        </button>
      </div>
      <Navbar className="navbar-wrapper" changePage={setActivePage} currentPage={activePage !== undefined ? activePage : "LANDING"} currentSubPage={activeSubPage} />
      {mobileNavbar &&
        <AnimatePresence>
          <MobileNavbar changeSubpage={setActiveSubPage} changePage={setActivePage} currentPage={activePage !== undefined ? activePage : "LANDING"} currentSubPage={activeSubPage !== undefined ? activeSubPage : "NEWYORK"} closeMobileNavbar={closeMobileNavbar} />
        </AnimatePresence>
      }
      {/*<hr className = "divider-line"/>*/}


      <Suspense fallback={null}>
        {(() => {
          switch (activePage) {
            case 'LANDING':
              return <Landing />
            case 'SELECTED WORKS':
              return <SelectedWorks subPage={activeSubPage === undefined ? "NEWYORK" : activeSubPage} />
            case "ILLUSTRATIONS":
              return <Illustrations />
            case "BOOKS":
              return <IllustrationsSubpage subPage="BOOKS" />
            case "EDITORIAL":
              return <IllustrationsSubpage subPage="EDITORIAL" />
            case "CORPORATE ILLUSTRATIONS":
              return <IllustrationsSubpage subPage="CORPORATE ILLUSTRATIONS" />
            case "ABOUT":
              return <About />
            case "STATEMENT":
              return <Statement />
            case "STATEMENT_BACKUP":
              return <StatementBackup />
            case "TIMELINE":
              return <Sketchbooks />
            case "CONTACT":
              return <Contact />
            case "EXHIBITIONS":
              return <Exhibitions />
            case "INTERVIEWS":
              return <Interviews />
            case "INTERVIEWS_BACKUP":
              return <InterviewsBackup />
            case "NOT_FOUND":
              return <NotFound />
            default:
              return <Landing activePage={activePage} />
          }
        })()}
      </Suspense>

      <Footer />
    </div>
  );
}

export default App;
